import React, {PropsWithChildren} from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {DialogHeaderBox} from '../../boxes/header/dialog-header.box';
import {DialogTitleBox} from '../../boxes/title/dialog-title.box';
import {DialogCloseButtonBox} from '../../boxes/close-button/dialog-close-button.box';
import {CyClass} from '../../../../../common/cy-classes';
import {HeaderButtonsContainerBox} from "../../boxes/header-buttons/header-buttons-container.box";

export interface ModalDialogHeaderComponentProps extends PropsWithChildren {
    title?: string;
    hideCloseButton?: boolean;
    onCloseButtonClick?: () => void;
    className?: string;
    renderExtraButtons?: () => React.ReactElement;
}
export class DialogHeaderComponent extends OrbitComponent<ModalDialogHeaderComponentProps> {

    private _renderTitle() {
        if(!this.props.title) {
            return null;
        }

        return (<DialogTitleBox className='dialog-header-title'>
            {this.props.title}
        </DialogTitleBox>);
    }

    private _renderCloseButton() {
        if(this.props.hideCloseButton) {
            return null;
        }

        return (
            <DialogCloseButtonBox className={CyClass('cy-modal-dialog-x-close-button')} onClick={this.props.onCloseButtonClick}/>
        );
    }

    private _renderExtraButtons() {
        if(this.props.renderExtraButtons) {
            return this.props.renderExtraButtons();
        }
        return null;
    }

    private _renderButtons() {
        if(this.props.hideCloseButton && !this.props.renderExtraButtons) {
            return null;
        }
        return (
            <HeaderButtonsContainerBox>
                {this._renderExtraButtons()}
                {this._renderCloseButton()}
            </HeaderButtonsContainerBox>
        )

    }

    private _renderContent() {
        if (this.props.children) {
            return this.props.children
        }

        return (
            <>
                {this._renderTitle()}
                {this._renderButtons()}
            </>
        );
    }

    render() {
        if(!this.props.title && this.props.hideCloseButton && !this.props.children) {
            return null;
        }

        let height: number | null = null;

        return (
            <DialogHeaderBox className={`${CyClass('cy-modal-dialog-header')} ${this.props.className? this.props.className : ''}`} height={height}>
                {this._renderContent()}
            </DialogHeaderBox>
        )
    }

}